import { ArrayUtils } from '../utils';

// Taks an array of notifications and generates an Object with _id as the keys and another object with type as the keys
const getSortedNotificationsObject = (notifications) => {
  const notifs    = notifications || [];
  var idDict      = {};
  var typeDict    = {};
  var consultDict = {};
  var existingArray = [];

  notifs.forEach((notification) => {
    idDict[notification._id] = notification;
    const consultation_id = notification && notification.data && notification.data.consultation_id ? notification.data.consultation_id : '';
    if (typeDict[notification.type]) {
      existingArray = typeDict[notification.type];
      existingArray.push(notification);
    } else {
      existingArray = [];
      existingArray.push(notification);
      typeDict[notification.type] = existingArray;
    }
    if (consultation_id) {
      consultDict[consultation_id] = true;
    }
  });

  return {
    dict: idDict,
    typeDict: typeDict,
    consultDict: consultDict,
  }
}

const addNotificationToAll = (notification, idDict, typeDict, consultDict) => {
  const _id  = notification._id;
  const type = notification.type;

  const newIdDict      = Object.assign({}, idDict);
  const newTypeDict    = Object.assign({}, typeDict);
  const newConsultDict = Object.assign({}, consultDict);
  const alreadyExisted = newIdDict[_id] ? true : false;

  if (!alreadyExisted) {
    newIdDict[_id] = notification;
    const consultation_id = notification && notification.data && notification.data.consultation_id ? notification.data.consultation_id : '';
    if (newTypeDict[type]) {
      var existingArray = newTypeDict[type];
      existingArray.push(notification);
    } else {
      var existingArray = [];
      existingArray.push(notification);
      newTypeDict[type] = existingArray;
    }
    if (consultation_id) {
      newConsultDict[consultation_id] = true;
    }
  }

  return {
    dict: newIdDict,
    typeDict: newTypeDict,
    consultDict: newConsultDict,
  }
}

const getBadgeCountForNavItem = (itemName, practice_id, notificationsTypeDict, notificationsDict) => {
  var notifTypeDict = notificationsTypeDict || {};
  var badgeCount = 0;

  switch (itemName) {
    case 'HOME':
      badgeCount = badgeCount + getBadgeCountForType('new_unassigned_client'    , practice_id, notifTypeDict);
    break;
    case 'CONSULTATIONS':
      badgeCount = badgeCount + getBadgeCountForType('new_consultation_created' , practice_id, notifTypeDict);
      badgeCount = badgeCount + getBadgeCountForType('added_to_consultation'    , practice_id, notifTypeDict);
      badgeCount = badgeCount + getBadgeCountForType('consultation_new_message' , practice_id, notifTypeDict);
    break;
    case 'PRACTICE':
      badgeCount = badgeCount + getBadgeCountForType('new_practice_join_request', practice_id, notifTypeDict);
    break;
    case 'STAFF':

    break;
    case 'CLIENTS':

    break;
    case 'MY ACCOUNT':
      badgeCount = badgeCount + getOtherPracticeNotificationCount(practice_id, notificationsDict);
    break;
    default:

  }

  return badgeCount;
}

const getBadgeCountForType = (notificationType, practice_id, notifTypeDict) => {
  var badgeCount = 0;
  var typeDict   = notifTypeDict || {};
  var notifArray = typeDict[notificationType];

  if (notifArray && ArrayUtils.isArray(notifArray)) {
    notifArray.forEach((notification) => {
      if (practice_id === notification.practice_id) {
        badgeCount = badgeCount + 1;
      }
    });
  }

  return badgeCount;
}

const getOtherPracticeNotificationCount = (current_practice_id, notificationDict) => {
  var allNotifIds = Object.keys(notificationDict);
  var badgeCount = 0;

  allNotifIds.forEach((notif_id) => {
    const notification = notificationDict[notif_id];
    if (notification && notification.practice_id !== current_practice_id) {
      badgeCount = badgeCount + 1;
    }
  })

  return badgeCount;
}

const getPracticeNotificationCount = (practice_id, notificationDict) => {
  var allNotifIds = Object.keys(notificationDict);
  var badgeCount = 0;

  allNotifIds.forEach((notif_id) => {
    const notification = notificationDict[notif_id];
    if (notification && notification.practice_id === practice_id) {
      badgeCount = badgeCount + 1;
    }
  })

  return badgeCount;
}

const getNotificationsForConsultation = (consultation_id, notificationDict) => {
  var consultNotifications = [];
  var allNotifIds = Object.keys(notificationDict);

  allNotifIds.forEach((notif_id) => {
    const notification = notificationDict[notif_id];
    const consult_id = notification && notification.data && notification.data.consultation_id ? notification.data.consultation_id : '';
    if (consultation_id === consult_id) {
      consultNotifications.push(notification);
    }
  })

  return consultNotifications;
}

export default {
  addNotificationToAll,
  getSortedNotificationsObject,
  getBadgeCountForType,
  getBadgeCountForNavItem,
  getPracticeNotificationCount,
  getOtherPracticeNotificationCount,
  getNotificationsForConsultation,
}
